import { createAction } from '@reduxjs/toolkit';

const actionName = (name) => 'VPN_' + name;

const setCurrentCommunity = createAction(actionName('SET_CURRENT_COMMUNITY'));

export { setCurrentCommunity };
